export default "__VITE_ASSET__9e510524__"